/* eslint-disable */
import { useEffect, useState } from "react";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import ReviewHeading from "../../../../shared/ReviewHeading";
import OtherPolicyReview from "./OtherPolicyReview";
import PlanDetailsReview from "./PlanDetailsReview";
import PlanReview from "./PlanReview";
import PremiumDetailsReview from "./PremiumDetailsReview";
import PremiumFundingReview from "./PremiumFundingReview";
import { useMutation } from "react-query";
import { generateMef, sendReviewLink } from "src/services/VerifyCustomer";
import CustomBackDrop from "src/shared/CustomBackDrop";
import OTPSuccessModal from "src/shared/CustomSuccessModal";
import { useNavigate } from "react-router-dom";
import store from "src/redux/store";
import { setMefUploadModal } from "src/redux/Actions/common";
import CustomerDeclaration from "./CustomerDeclaration";
import CustomerDeclarationDataEntry from "./CustomerDeclarationDataEntry";
import { UploadSignedMefForm } from "src/services/UploadSignedMefForm";
import { roleIDs } from "src/config/constant";
import StorageService from "src/utils/Storage/storageService";
import RidersReview from "./RidersReview";

// interface Props {
//   stepNo: number;
//   setStepNo: Dispatch<SetStateAction<number>>;
// }

function LoanReview() {
  // function onBack() {
  //   setStepNo(stepNo - 1);
  // }

  // function onNext() {
  //   // Set isModal to true to show the CustomModals component
  //   setIsModal(true);
  // }
  const navigate = useNavigate();
  const leadId = useAppSelector((state) => state.common.leadId);
  const loanDetails = useAppSelector((state) => state.loanDetails);
  // const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [verifyButtonState, setVerifyButtonState] = useState(false);
  const [successModalState, setSuccessModalState] = useState(false);
  const [successModalDataEntry, setSuccessModalDataEntry] = useState(false);
  const user = StorageService.getFromLocalStorage("user");
  const isRiderActive = useAppSelector((state) => state?.loanDetails?.isRiderSelectionLocked);

  const downloadPDF = (pdf: any) => {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = "MEF Form.pdf";
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };
  const { mutate: callGenerateMef, isLoading: isGenerateMefLoading } = useMutation(generateMef, {
    onSuccess: (res) => {
      downloadPDF(res?.data);
      navigate(`/review-details/${leadId}`);
      setVerifyButtonState(true);
    }
  });
  const { mutate, isLoading } = useMutation(() => sendReviewLink(leadId), {
    retry: false,
    onSuccess: () => {
      setSuccessModalState(true);
      // window.open("/review-details?id=ee05e9fa-97d0-4a4f-80e8-1a243e4dd255", "_blank");
    }
  });

  const handleVerifyByOtp = () => {
    mutate();
  };

  const { mutate: uploadMutation, isLoading: isMEFFormViaDataEntryLoading } = useMutation<
    any,
    any,
    { leadId: string; file: File | null }
  >(UploadSignedMefForm, {
    retry: false,
    onSuccess: () => {
      setSuccessModalDataEntry(true);
    }
  });

  useEffect(() => {
    store.dispatch(setMefUploadModal({ modalState: false }));
  }, []);

  return (
    <>
      <CustomBackDrop open={isLoading || isGenerateMefLoading || isMEFFormViaDataEntryLoading} />
      <div className="lg:ml-24 lg:mr-24 max-sm:ml-4 md:max-lg:px-10 max-sm:mr-4  font-montserrat">
        <ReviewHeading label="Loan Details" />
        <PlanReview />
        <PlanDetailsReview />
        <PremiumDetailsReview />
        <PremiumFundingReview />
        {isRiderActive && <RidersReview />}
        {loanDetails.existingPolicy.existingLifeCover && <OtherPolicyReview />}

        {roleIDs.nbgo === user.role ? (
          <CustomerDeclarationDataEntry uploadMutation={uploadMutation} />
        ) : (
          <CustomerDeclaration
            handleVerifyByOtp={handleVerifyByOtp}
            callGenerateMef={callGenerateMef}
            verifyButtonState={verifyButtonState}
          />
        )}
        {/* Render CustomModals when isModal is true */}
        {successModalState && (
          <OTPSuccessModal
            shortMessage="Review link sent"
            longMessage="Review link has been sent successfully!"
          />
        )}
        {successModalDataEntry && (
          <OTPSuccessModal
            shortMessage="MEF Submitted"
            longMessage="MEF has been submitted successfully!"
          />
        )}
      </div>
    </>
  );
}

export default LoanReview;
